import planFeatures from './planFeatures.json';

export const PLAN_CATEGORIES = planFeatures.categories;
